
const torneoRutes = [
  {
    path: '/ds/torneo/:idTorneo',
    component: () => import('../views/torneo/IndexTorneoUser.vue'),
    children: [
      {
        path: 'info',
        name: 'torneo-user-info',
        component: () => import('../views/torneo/InfoTorneoUser.vue'),
      },
      {
        path: 'equipos',
        name: 'torneo-user-teams',
        component: () => import('../views/torneo/EquiposTorneoUser.vue'),
      },
      {
        path: 'calendario',
        name: 'torneo-user-calendario',
        component: () => import('../views/torneo/CalendarioTorneoUser.vue'),
      },
      {
        path: 'resultados',
        name: 'torneo-user-resultados',
        component: () => import('../views/torneo/ResultadosTorneoUser.vue'),
      },
      {
        path: ':idMatch/ficha-control',
        name: 'torneo-user-ficha',
        component: () => import('../views/torneo/FichaControlTorneoUser.vue'),
      },
      {
        path: 'tabla',
        name: 'torneo-user-tabla',
        component: () => import('../views/torneo/TablaTorneoUser.vue'),
      },
      {
        path: 'equipo/:idIns/partidos',
        name: 'torneo-team-partidos',
        component: () => import('../views/torneo/MatchesByTeamPage.vue'),
      },
      {
        path: 'estadisticas',
        component: () => import('../views/torneo/EstadisticasTorneoUser.vue'),
        children: [
          {
            path: 'goles',
            name: 'torneo-user-estadisticas',
            component: () => import('../views/torneo/GoleadoresTorneouser.vue'),
          },
          {
            path: 'detalle-goles/:idPlayer',
            name: 'torneo-user-detail-goles',
            component: () => import('../views/torneo/DetalleGolesPlayerPage.vue'),
          },
          {
            path: 'amarillas',
            name: 'torneo-user-amarillas',
            component: () => import('../views/torneo/AmarillasTorneoUser.vue'),
          },
          {
            path: 'rojas',
            name: 'torneo-user-rojas',
            component: () => import('../views/torneo/RojasTorneoUser.vue'),
          },
          {
            path: 'azules',
            name: 'torneo-user-azules',
            component: () => import('../viewshop/torneo/AzulesTorneoUser.vue'),
          },
        ]
      },
      {
        path: 'noticias',
        name: 'torneo-user-news',
        component: () => import('../views/torneo/NewsTorneoUser.vue'),
      },
    ]
  },
]

export default torneoRutes